import { createReducer } from '@reduxjs/toolkit';
import { arrayMoveImmutable } from 'array-move';
import { SmoMoon } from '../../../../Models/Smo/SmoMoon';
import { DEFAULT_GAME_LANGUAGE } from '../../../../Utils/Constants';
import { addBuilderStateCase } from '../../Global/ComponentState/ComponentStateReducer';
import CreateMoonListActions from './CreateMoonListActions';
import { CreateMoonListState } from './CreateMoonListState';

const initialState: CreateMoonListState = {
  state: { current: 'data' },
  name: '',
  isPublic: true,
  search: '',
  searchLanguage: DEFAULT_GAME_LANGUAGE,
  searchResults: [],
  moons: []
};
export const createMoonListReducer = createReducer<CreateMoonListState>(initialState, (builder) => {
  addBuilderStateCase(builder, 'CREATE_MOON_LIST');
  builder.addCase(CreateMoonListActions.resetState, () => initialState);
  builder.addCase(CreateMoonListActions.createFromMoonList, (state, action) => ({
    ...state,
    name: action.payload.name + ' 2',
    moons: action.payload.moons
  }));
  builder.addCase(CreateMoonListActions.setName, (state, action) => ({ ...state, name: action.payload }));
  builder.addCase(CreateMoonListActions.setIsPublic, (state, action) => ({ ...state, isPublic: action.payload }));
  builder.addCase(CreateMoonListActions.setSearch, (state, action) => ({ ...state, search: action.payload }));
  builder.addCase(CreateMoonListActions.setSearchResults, (state, action) => ({
    ...state,
    searchResults: action.payload
  }));
  builder.addCase(CreateMoonListActions.setSearchLanguage, (state, action) => ({
    ...state,
    searchLanguage: action.payload
  }));
  builder.addCase(CreateMoonListActions.addMoon, (state, action) => ({
    ...state,
    moons: [...state.moons.filter((moon: SmoMoon) => moon.id !== action.payload.id), action.payload]
  }));
  builder.addCase(CreateMoonListActions.moveMoon, (state, action) => ({
    ...state,
    moons: arrayMoveImmutable(state.moons, action.payload.atIndex, action.payload.toIndex)
  }));
  builder.addCase(CreateMoonListActions.removeMoonWithId, (state, action) => ({
    ...state,
    moons: state.moons.filter((moon: SmoMoon) => moon.id !== action.payload)
  }));
});
